import React from 'react';
import { withLocalePrefix } from 'shared/utils/translation';
import EditingOffices from '../edit/offices';
import type { Office } from '../../shared/types';
import { MultipleRulesContext } from '../../multiple_rules/context';
import type { DataCollectionRuleInterface } from '../data_collection_rule';
import EmptyState from '../../shared/empty_state';
import Names from '../../shared/names';

const t = withLocalePrefix('gdpr.data_collection_rules.view.table');

type Props = {
  editing: boolean;
  rule: DataCollectionRuleInterface;
  setRule: any;
};

const hasAllOfficesSelected = (rule: DataCollectionRuleInterface) =>
  !!rule.all_offices;
const hasOffices = (rule: DataCollectionRuleInterface) =>
  rule.office_ids && rule.office_ids.length;
type FlattenOfficesReducer = (arg1: Array<Office>) => Array<Office>;
const flattenOffices: FlattenOfficesReducer = (offices) =>
  offices.flatMap(({ children = [], ...office }) => {
    if (children?.length) {
      // @ts-expect-error - TS2769 - No overload matches this call.
      return flattenOffices(children).concat(office);
    }

    return office as Office;
  });

export default function Offices({ editing, rule, setRule }: Props) {
  const { offices } = React.useContext(MultipleRulesContext);
  const flattenedOffices = React.useMemo(
    () => flattenOffices(offices),
    [offices]
  );

  if (editing) {
    return <EditingOffices rule={rule} setRule={setRule} />;
  } else if (hasAllOfficesSelected(rule)) {
    return <span>{t('rule.all_offices')}</span>;
  } else if (!hasOffices(rule)) {
    // @ts-expect-error - TS2769 - No overload matches this call.
    return <EmptyState empshazie>{t('rule.no_offices')}</EmptyState>;
  } else {
    return (
      <Names
        names={flattenedOffices.reduce<Array<any>>(
          (acc, office) =>
            // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'number'.
            rule.office_ids.includes(office.id) ? acc.concat(office.text) : acc,
          []
        )}
      />
    );
  }
}
